// Copyright (c) 2018 Comsearch, Inc., All rights reserved

// makes two empty quick add site objects
// with the elevationUnit based on the project's unit type
const getSitesValues = unitType => (
  Array.from({ length: 2 }, () => ({
    asr: '',
    callSign: '',
    elevation: '',
    elevationUnit: unitType,
    latitude: '',
    longitude: '',
    siteName: '',

    // these fields are not visible in the UI but are populated if the user
    // selects a site from the auto suggest.
    expirationDate: null,
    licenseBasisId: null,
    radioServiceId: null,
    stateId: null,
    stationClassId: null,
  }))
)

const getInitialQuickAddValues = unitType => ({
  band: '',
  pathName: '',
  sites: getSitesValues(unitType),
  unitType,
})

export default getInitialQuickAddValues
